/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { FaGlobe } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { COLORS } from "./hero.constants";

export default function NavbarMobile({ isArabic, onToggleLang, onClose }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      className="position-absolute w-100 start-0 shadow-sm"
      style={{
        top: "65px",
        background: COLORS.darkPurple,
        borderRadius: "0 0 14px 14px",
        padding: "20px 0",
        direction: isArabic ? "rtl" : "ltr",
        zIndex: 999,
        color: COLORS.textLight,
      }}
    >
      <div className="d-flex flex-column align-items-center gap-3">
        <button
          className="btn border-0 d-flex align-items-center gap-1 fw-semibold"
          style={{ color: COLORS.textLight }}
          onClick={onToggleLang}
        >
          <FaGlobe color={COLORS.gold} /> {isArabic ? "EN" : "AR"}
        </button>

        <button
          className="btn fw-semibold"
          style={{
            color: COLORS.gold,
            border: `1px solid ${COLORS.gold}`,
            borderRadius: "8px",
            padding: "6px 14px",
            background: "transparent",
          }}
          onClick={() => {
            onClose();
            navigate("/login");
          }}
        >
          {t("login.signIn")}
        </button>

        <button
          className="btn fw-semibold px-4 py-2"
          style={{
            background: COLORS.gold,
            color: COLORS.darkPurple,
            borderRadius: 10,
          }}
          onClick={() => {
            onClose();
            navigate("/signup");
          }}
        >
          {t("create")}
        </button>
      </div>
    </div>
  );
}
